import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, Store, Settings as SettingsIcon } from "lucide-react";
import { Button } from "./ui/button";

export const AppHeader = ({ title, subtitle }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-10 h-10 rounded-xl bg-emerald-600 text-white grid place-items-center shrink-0">
          <Store className="w-5 h-5" strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <h1 data-testid="app-title" className="text-lg font-bold text-slate-900 truncate">
            {title || "KonexoCRM"}
          </h1>
          {subtitle ? (
            <p className="text-xs text-slate-500 truncate">{subtitle}</p>
          ) : (
            <p className="text-xs text-slate-500 truncate">Business Connected</p>
          )}
        </div>
      </div>
      {user && (
        <div className="flex items-center gap-1">
          {user.role === "owner" && (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => navigate("/settings")}
              data-testid="header-settings-btn"
              className="rounded-full h-10 w-10 text-slate-600 hover:text-indigo-600"
              title="Settings"
            >
              <SettingsIcon className="w-5 h-5" strokeWidth={2.5} />
            </Button>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={logout}
            data-testid="logout-btn"
            className="rounded-full h-10 w-10 text-slate-600 hover:text-red-600"
            title="Logout"
          >
            <LogOut className="w-5 h-5" strokeWidth={2.5} />
          </Button>
        </div>
      )}
    </header>
  );
};
